<template>
  <van-dialog 
    v-model="isVisible"
    className="dialog"
    theme="round"
    @confirm="confirm">
    <div class="dialog-title" slot="title">
      <div class="dialog-title-txt">{{title}}</div>
      <van-icon class="close-icon" name="cross" size="22" @click="onClose"/>
    </div>
    <div class="dialog-content">
      <div v-html="content"></div>
    </div>
  </van-dialog>
</template>

<script>
export default {
  name: 'c-dialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      default: '提示',
      type: String
    }
  },
  data() {
    return {
      isVisible: false,
      content: '',
      confirmCallback: null
    }
  },
  methods: {
    onClose() {
      this.isVisible = false;
      this.confirmCallback('cancel')
    },
    open({content,title}) {
      this.isVisible = true;
      this.content = content
      this.title = title?title:'提示'
    },
    confirm() {
      this.confirmCallback('confirm')
    }
  }
}
</script>

<style lang="stylus" scoped>
.dialog
  border-radius: 12px
  .dialog-title
    position relative
    &-text
      text-align: center
    .close-icon
      display: inline-block
      position absolute
      right 10px
      top 0
    
  .dialog-content
    text-align center
    padding 0 15px
    line-height 1.4
    >>> .van-field .van-field__value input
      color #FF6B31
  >>> .van-dialog__header
    padding 20px 0
  >>> .van-dialog__footer button
    margin 15px 15px 20px
    padding 10px 0
    border-radius 25px
    height: auto
    line-height 1
    color #fff
    background: linear-gradient(#FF8820, #FF6B31)

  .field-item
    // margin 15px 0
    display: flex
    justify-content: space-between
    align-items: center
    padding 10px 16px
    font-size 14px
    background-color: #fff
    border-radius: 8px
    &-title
      color #323233
      // font-weight 600
</style>